// Ondergrond voor elke Leaflet-kaart: OpenFreeMap, door MapLibre getekend binnen een
// Leaflet-laag (zelfde opzet als base-craft). Gratis en zonder API-key. CARTO zette zijn
// kaarten achter een betaalde key en toonde daarna "API key required" op elke tegel.
import L from "leaflet";
import { setWorkerUrl } from "maplibre-gl";
import maplibreWorkerUrl from "maplibre-gl/dist/maplibre-gl-worker.mjs?worker&url";
import "maplibre-gl/dist/maplibre-gl.css";
import "@maplibre/maplibre-gl-leaflet";

// MapLibre bouwt de workernaam pas at runtime; zonder dit belandt de worker niet in
// web/dist en blijft de kaart na een build leeg, zonder foutmelding.
// Vraagt `worker: { format: "es" }` in vite.config.js.
setWorkerUrl(maplibreWorkerUrl);

const MAP_STYLE = "https://tiles.openfreemap.org/styles/positron";

// Licentievoorwaarde van OpenFreeMap: niet inkorten of verbergen.
const MAP_ATTRIBUTION =
    '<a href="https://openfreemap.org" target="_blank">OpenFreeMap</a> ' +
    '<a href="https://www.openmaptiles.org/" target="_blank">&copy; OpenMapTiles</a> ' +
    'Data from <a href="https://www.openstreetmap.org/copyright" target="_blank">OpenStreetMap</a>';

// Plaatsnamen in de taal van de pagina (Craft zet <html lang> per site). OpenMapTiles heeft
// per feature `name:nl`, `name:fr`, …; de eigen expressie van de stijl blijft de fallback.
const translateLabels = (glMap) => {
    const lang = (document.documentElement.lang || "").split("-")[0].toLowerCase();
    if (!lang) return;

    const apply = () => {
        (glMap.getStyle()?.layers ?? []).forEach((layer) => {
            if (layer.type !== "symbol") return;
            const current = glMap.getLayoutProperty(layer.id, "text-field");
            if (!current) return;
            glMap.setLayoutProperty(layer.id, "text-field", ["coalesce", ["get", `name:${lang}`], current]);
        });
    };

    if (glMap.isStyleLoaded()) apply();
    else glMap.once("styledata", apply);
};

// De kaart moet met `attributionControl: true` aangemaakt zijn. De bridge is een L.Class,
// geen L.Layer: Leaflet vraagt hem geen attributie, dus die zetten we zelf in het vak.
export const addBasemap = (map) => {
    const glLayer = L.maplibreGL({ style: MAP_STYLE, attributionControl: false }).addTo(map);
    map.attributionControl.addAttribution(MAP_ATTRIBUTION);
    // Leaflets standaardprefix zonder de vlag.
    map.attributionControl.setPrefix('<a href="https://leafletjs.com" target="_blank">Leaflet</a>');
    // De MapLibre-kaart bestaat pas zodra de Leaflet-kaart een positie heeft
    // (op de pand-pagina pas na het geocoderen).
    map.whenReady(() => translateLabels(glLayer.getMaplibreMap()));
};
